<template>
  <HelmetProvider>
    <Helmet>
      <title>{{ title }} </title>
      <!-- Google Tag Manager / Google Analytics -->
      <script type="application/javascript">
        {{ googleTagManagerScript }}
      </script>
      <!-- End Google Tag Manager / Google Analytics -->

      <!-- Pardot Tracking Script -->
      <script type="application/javascript">
        {{ pardotScript }}
      </script>
      <!-- End Pardot Tracking Script -->
    </Helmet>
  </HelmetProvider>
</template>

<script>
import { Helmet, HelmetProvider } from '@jnields/vue-helmet';
import headMixins from 'client/signup/mixins/head';
import headScripts from 'client/signup/headScripts/headScripts';

const {
  generateGoogleTagManager,
  title,
} = headMixins;
const { pardotScript } = headScripts;

export default {
  name: 'Head',
  components: {
    Helmet,
    HelmetProvider,
  },
  mixins: [
    generateGoogleTagManager('signup'),
    title('Signup'),
  ],
  data() {
    return {
      pardotScript,
    };
  },
};
</script>
